import clsx from "clsx";
import styles from "./styles.module.css";
import _isEmpty from "lodash/isEmpty";
import {
  TournamentStatus,
  WidgetItem,
} from "../../interfaces/TournamentsConfig";
import { useTranslation } from "react-i18next";
import { formatTimestampTo, getCurrentTimestamp } from "../../utils/DateUtils";
import { getResultOutTimeFormat } from "../../utils/helpers/common";
import GameStatusNotch from "../../components/GameStatusNotch";
import NxTimer from "../../components/NxTimer/NxTimer";
import { useCallback, useEffect, useState } from "react";
import { isNxSlotsAvailable } from "./helper";
import _map from "lodash/map";
import _isNil from "lodash/isNil";
import cargo from "../../utils/cargo";
import Skeleton from "../../components/Skeleton";
interface StickyBtnBlockProps {
  onClick: () => void;
  btnName: string;
  tournamentStatus: string;
  tournament?: WidgetItem;
  setTournamentCurrentStatus: () => void;
  disabled?: boolean;
}
interface IComponentUI {
  cta?: {
    text: string;
    isEnabled: boolean;
  };
  countdownText?: string;
}

const _id = `NX-BOTTOMBUTTON-COUNTDOWN`;

export const StickyBtnBlock: React.FC<StickyBtnBlockProps> = ({
  onClick,
  btnName,
  tournamentStatus,
  tournament,
  setTournamentCurrentStatus,
  disabled= false
}) => {
  const initialComponentUI = {
    cta: {
      text: 'Play Now',
      isEnabled: true,
    },
    countdownText: 'Time remaining: 00:00',
  };
  const { t } = useTranslation();
  const SKELETON_TIMEOUT = 0;
  const [componentUI, setComponentUI] = useState<IComponentUI>(initialComponentUI);
  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(true);
  const { tournamentResultOutTimeText, resultDeclareTime } = tournament || {};

  const updateTimer = useCallback(() => {
    setCountdown((old) => old - 1000);
  }, []);

  // Simulate loading effect
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), SKELETON_TIMEOUT);
    return () => clearTimeout(timer);
  }, [countdown]);

  useEffect(() => {
    let newComponentUI = initialComponentUI;
    // const tournament = getNXTournamentInfo()
    const {
      // registrationButtonMap,
      registrationStartTime,
      registrationEndTime,
      resultDeclareTime = 0,
      displayEndTime = 0,
      isSuspended,
      enableRegistration = true,
    } = tournament || {};
    const currentTime = getCurrentTimestamp();
    if (isSuspended) {
      // componentUI empty
    } else {
      switch (tournamentStatus) {
        case TournamentStatus.TOURNAMENT_NOT_STARTED:
          newComponentUI = {
            cta: {
              text: t("playNow"),
              isEnabled: false,
            },
            countdownText: `${t("nxTournamentStartsIn")}`,
          };
          break;
        case TournamentStatus.TOURNAMENT_LIVE_USER_NOT_ENTERED:
          newComponentUI = {
            cta: {
              text: t("playNow"),
              isEnabled: isNxSlotsAvailable() && enableRegistration,
            },
            countdownText: `${t("nxTournamentClosesIn")}`,
          };
          break;
        case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING:
          newComponentUI = {
            cta: {
              text: t("playAgain"),
              isEnabled: isNxSlotsAvailable() && enableRegistration,
            },
            countdownText: `${t("nxTournamentClosesIn")}`,
          };
          break;
        case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING:
          newComponentUI = {
            cta: {
              text: t("playAgain"),
              isEnabled: false,
            },
            countdownText: `${t("nxTournamentClosesIn")}`,
          };
          break;
        case TournamentStatus.TOURNAMENT_CLOSED_RESULT_PENDING:
          newComponentUI = {
            cta: {
              text: t("playAgain"),
              isEnabled: false,
            },
            countdownText: `${t("results_at", {
              time: formatTimestampTo(
                resultDeclareTime,
                getResultOutTimeFormat(resultDeclareTime)
              ),
            })}`,
          };
          // break;
          setCountdown(resultDeclareTime - currentTime);
          cargo.set(_id, updateTimer);
          break;
        case TournamentStatus.TOURNAMENT_CLOSED_RESULT_OUT:
          newComponentUI = {
            cta: {
              text: t("playAgain"),
              isEnabled: false,
            },
            countdownText: '',
          };
          setCountdown(displayEndTime - currentTime);
          cargo.set(_id, updateTimer);
          break;
        case TournamentStatus.TOURNAMENT_CLOSED_DISPLAY_ENDED:
          newComponentUI = {
            cta: {
              text: t("playAgain"),
              isEnabled: false,
            },
            countdownText: '',
          };
          break;
        default:
          break;
      }
    }
    setComponentUI(newComponentUI);
  }, [t, tournament, tournamentStatus, updateTimer, countdown]);

  useEffect(() => {
    if (!_isNil(countdown) && countdown <= 0) {
      setTournamentCurrentStatus();
      cargo.purge(_id);
      return;
    }
  }, [countdown, setTournamentCurrentStatus]);

  return (
    <>
      <div className={clsx(styles.stickyBtnBox, "bgWhite")}>
        <button
          className={clsx(styles.playNowBtn, "btn primaryBtn")}
          onClick={onClick}
          disabled={!componentUI?.cta?.isEnabled}
        >
          {componentUI?.cta?.text}
        </button>
        <div
          className={clsx(
            styles.timeLeft,
            "fontWeightBold fontSizeSm14 fontColor333"
          )}
        >
          {/* <NxTimer
            // containerStyles={styles.buttonText}
            tournament={tournament}
            // textStyles={getStyle('b2_med')}
            timerText={componentUI?.countdownText}
            ignoreShowTimerFlag={true}
            runWhenTimerReachesZero={setTournamentCurrentStatus}
            textStyles={undefined}
            containerStyles={undefined}
          />

          {_isEmpty(tournament?.tournamentResultOutTimeText)
            ? t("finalResultOutAt", {
                time: formatTimestampTo(
                  tournament?.resultDeclareTime,
                  getResultOutTimeFormat(resultDeclareTime)
                ),
              })
            : tournamentResultOutTimeText} */}
          {false ? (
            <Skeleton variant="text" />
          ) : countdown <= 0 ? (
            <NxTimer
              // containerStyles={styles.buttonText}
              tournament={tournament}
              // textStyles={getStyle('b2_med')}
              timerText={componentUI?.countdownText}
              ignoreShowTimerFlag={true}
              runWhenTimerReachesZero={setTournamentCurrentStatus}
              textStyles={undefined}
              containerStyles={undefined}
            />
          ) : _isEmpty(tournament?.tournamentResultOutTimeText) ? (
            t("finalResultOutAt", {
              time: formatTimestampTo(
                tournament?.resultDeclareTime,
                getResultOutTimeFormat(resultDeclareTime)
              ),
            })
          ) : (
            tournamentResultOutTimeText
          )}
        </div>
        {/* <GameStatusNotch tournament={tournament} /> */}
      </div>
    </>
  );
};
